export default {
  buttons: {
    add: 'Tilføj',
  },
  AddOn: {
    label: 'Tilkøb',
    title: 'Få din mobilapp',
    subscribed: 'Abonneret',
    cta: 'Få din mobilapp',
    price_per_month: '{{price}} / måned',
    tax_included: 'inkl. gældende moms',
    apple_developer_note:
      'Kræver en Apple Developer-konto (99 $/år, betales til Apple) i restaurantens juridiske enhed.',
    features: {
      stores: 'Findes i App Store og Google Play',
      push: 'Push-notifikationer til dine gæster',
      loyalty: 'Loyalitetspoint og belønninger',
      commission: 'Direkte bestilling med 0 % kommission',
    },
  },
};
